<template lang="pug">
.tooltip-input.form-group.nickname.input-group
  .input-group-prepend
    i(v-if="clearable" class="input-group-text geno-default-icons users_single-02")
  input.form-control.pac-target-input(type="text", ref="selectalias", :name="name", :placeholder="placeholder", v-model="inputValue", spellcheck="false", autocomplete="off", autofill="off", @input="handleInput", @keyup.enter="setInputVal", @focus="onFocus", @blur="onBlur", @keydown.down.prevent="onArrowDown", @keydown.up.prevent="onArrowUp", @keydown.enter.prevent="onEnter")
  i(v-if="clearable && inputValue && inputValue.length > 0", class="nickname el-select__caret el-input__icon el-icon-circle-close", @click="clearInput")
  i(v-if="!clearable && inputValue && inputValue.length > 0", class="nickname generic el-select__caret el-input__icon el-icon-circle-close", @click="clearInput" v-tooltip="'clear input'")
  portal(to="dropdowntip", v-if="showTooltip && filteredSuggestions.length")
    transition(name="slide-down")
      ul.custom-tooltip(:style="dropdownStyle")
        li.tooltip-item(v-for="(suggestion, index) in filteredSuggestions", :key="index", :class="{ 'is-active': index === highlightedIndex }" :style="'overflow-x: hidden;'") 
          div.text(@click="selectSuggestion(suggestion)" style="flex:1;cursor:pointer;") {{ suggestion }}
          div.remove(v-if="editable" @click.stop="removeItem(suggestion, index)" style="width: 20px;margin-left:5px;margin-right: -5px; color:#aaa;cursor:pointer;font-size:16px;width: 20px;float:right;z-index: +1;" aria-label="Remove search") ×
</template>
<script>
  import debounce from 'lodash/debounce';
  export default {
      props: {
          suggestions: {
              type: Array,
              required: true,
              default: () => [],
          },
          placeholder: {
              type: String,
              required: true,
              default: () => 'Type something...',
          },
          portal: {
              type: String,
              required: false,
              default: () => '',
          },
          initValue: {
              type: String,
              required: true,
              default: () => '',
          },
          name: {
              type: String,
              required: true,
              default: () => 'Alias',
          },
          clearable: {
              type: Boolean,
              required: false,
              default: () => true,
          },
          editable: {
              type: Boolean,
              required: false,
              default: () => false,
          },
      },
      data() {
          return {
              inputValue: '',
              showTooltip: false,
              dropdownStyle: null,
              highlightedIndex: -1,
          };
      },
      computed: {
          portalTargetExists() {
              return this.portal && !!document.getElementById(this.portal);
          },
          filteredSuggestions() {
              if (!this.inputValue) {
                  return this.suggestions
              }
              const lowerInput = this.inputValue.toLowerCase();
              return this.suggestions.filter((suggestion) =>
                  suggestion.toLowerCase().includes(lowerInput)
              );
          },
      },
      mounted() {
          this.inputValue = this.initValue ? this.initValue : '';
          if (this.showTooltip) this.$nextTick(this.updateDropdownPosition);
          this.debouncedUpdatePosition = debounce(this.updateDropdownPosition, 50);
          window.addEventListener('resize', this.debouncedUpdatePosition);
          window.addEventListener('scroll', this.debouncedUpdatePosition, true);
      },
      watch: {
          showTooltip(val) {
              if (val) this.$nextTick(this.updateDropdownPosition);
          }
      },
      beforeDestroy() {
          window.removeEventListener('resize', this.debouncedUpdatePosition);
          window.removeEventListener('scroll', this.debouncedUpdatePosition, true);
      },
      methods: {
					  removeItem(item, idx) {
    					this.$emit('remove-item', item, idx);
  					},
          updateDropdownPosition() {
              const input = this.$refs.selectalias;
              if (input) {
                  const rect = input.getBoundingClientRect();
                  this.dropdownStyle = {
                      position: 'absolute',
                      left: `${rect.left + window.scrollX}px`,
                      top: `${rect.bottom + window.scrollY}px`,
                      width: `${rect.width}px`,
                      overflowX: 'hidden',
                      zIndex: 99999
                  };
              }
          },
          clearInput() {
              this.inputValue = '';
              this.$emit('input', this.inputValue);
              setTimeout(() => {
                  this.$refs['selectalias'].blur()
              }, 0)
          },
          onInput() {
              this.showTooltip = true;
          },
          handleInput() {
              this.$emit('input', this.inputValue);
              this.showTooltip = true;
          },
          setInputVal(evt) {
              this.$emit('sendToParent', evt)
              this.$nextTick(() => {
                  this.$refs['selectalias'].blur()
              })
          },
          onFocus() {
              this.showTooltip = true;
          },
          onBlur() {
              setTimeout(() => {
                  this.showTooltip = false;
              }, 200); // Delay to allow click on suggestion
          },
          onArrowDown() {
              if (this.highlightedIndex < this.filteredSuggestions.length - 1) {
                  this.highlightedIndex++;
              } else {
                  this.highlightedIndex = 0; // Loop back to the first item
              }
          },
          onArrowUp() {
              if (this.highlightedIndex > 0) {
                  this.highlightedIndex--;
              } else {
                  this.highlightedIndex = this.filteredSuggestions.length - 1; // Loop back to the last item
              }
          },
          onEnter() {
              if (this.highlightedIndex !== -1) {
                  this.selectSuggestion(this.filteredSuggestions[this.highlightedIndex]);
              }
          },
          selectSuggestion(suggestion) {
              this.inputValue = suggestion;
              this.$emit('input', this.inputValue);
              this.showTooltip = false;
              this.highlightedIndex = -1;
          },
      },
  };
</script>
<style scoped>
  .nickname.el-input__icon {
    opacity: 0.5 !important;
    cursor: pointer;
    position: absolute;
    right: 24px;
    z-index: 9;
  }

  .nickname.el-input__icon:hover {
    opacity: 0.5 !important;
    font-size: 2em;
  }
	i.generic {
	left: 50%;
	bottom: 2px;
	margin-left: 145px;
	}

  .tooltip-input {
    position: relative;
    width: 240px;
    overflow: visible;
  }

  #userprofile .tooltip-input input {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    padding-right: 30px;
    background: #f6fbff;
  }

  .tooltip-input ul {
    list-style: none;
    padding-inline-start: 0px;
    font-size: 12px;
    line-height: 12px;
    color: #555;
    max-width: 144px;
    border-bottom-right-radius: 9px;
    border-bottom-left-radius: 9px;
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
  }

  .custom-tooltip {
    position: absolute;
    top: 100%;
    left: 35px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
    z-index: 1000;
    max-height: 150px;
    overflow-y: hidden;
    list-style: none;
    padding-left: 0;
    font-size: 1em;
    opacity: 1;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .tooltip-item {
    cursor: pointer;
		display: flex ;
		opacity: 0.7;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-start;
    flex-direction: row;
  }
.tooltip-item .text {
	padding: 3px;
	padding-left: 15px;
}
.tooltip-item .remove {
	padding: 3px;
	padding-right: 25px;
}

  .tooltip-item::marker {
    display: none;
  }

  .tooltip-item.is-active,
  .tooltip-item:hover {
    background-color: #cddde6;
    ;
  }

  .custom-tooltip.enter-active,
  .custom-tooltip.leave-active {
    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  }

  .custom-tooltip.enter-from,
  .custom-tooltip.leave-to {
    max-height: 0;
    opacity: 0;
  }

  .custom-tooltip.enter-to,
  .custom-tooltip.leave-from {
    max-height: 150px;
    opacity: 1;
  }

  .slide-down-enter-active,
  .slide-down-leave-active {
    transition: all 0.3s ease;
  }

  .slide-down-enter-from,
  .slide-down-leave-to {
    transform: translateY(-10px);
    opacity: 0;
  }

  .slide-down-enter-to,
  .slide-down-leave-from {
    transform: translateY(0);
    opacity: 1;
  }
  .fade-dropdown-enter-active, .fade-dropdown-leave-active {
    transition: opacity 0.25s;
    }
    .fade-dropdown-enter, .fade-dropdown-leave-to {
      opacity: 0;
      }
</style>
